import { useState, useRef } from "react";
// import {
//   FormWrapper,
//   FormBoxText,
//   SubmitButton,
//   NotificationBox,
// } from "./ContactForm.styled";
import emailjs, { init } from "@emailjs/browser";
import {
  IoIosContact,
  IoIosPhonePortrait,
  IoIosMail,
  IoIosFiling,
} from "react-icons/io";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import style from "./ContactForm.module.scss";
import Policy from "../../assets/Polityka.pdf"


export const ContactForm = () => {
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [policy, setPolicy] = useState(false);

  init(`${process.env.REACT_APP_USER_KEY}`);
  const form = useRef();

  const inputChange = (e) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
    }
    if (name === "number") {
      setNumber(value);
    }
    if (name === "email") {
      setEmail(value);
    }
    if (name === "message") {
      setMessage(value);
    }
    if (name === "checkbox") {
      setPolicy(policy => !policy);
    }
  };

  const resetForm = () => {
    setName("");
    setNumber("");
    setEmail("");
    setMessage("");
    setPolicy(false);
  };

  const notify = () => {
    toast.success("Wiadomość została wysłana !", {
      position: toast.POSITION.TOP_CENTER,
      className: toastMessage,
    });
  };

  const valueSubmit = (e) => {
    e.preventDefault();
    // notify();
    // resetForm();
    const SERVICE = process.env.REACT_APP_SERVICE_KEY;
    const TEMPLATE = process.env.REACT_APP_TEMPLATE_KEY;
    const USER = process.env.REACT_APP_USER_KEY;
    if (1 === 0) {
      console.log("Incorrect data"); //stworzyc validator
    } else {
      emailjs
        .sendForm(`${SERVICE}`, `${TEMPLATE}`, form.current, `${USER}`)
        .then(
          () => {
            notify();
          },
          (error) => {
            console.log(error.text);
          }
        );
      console.log(name, number, email);
      resetForm();
    }
  };

  const { formWrapper, formBoxText, formBoxText_notActive, customCheck, checkLabel, checkLabel__checked, submitButton, submitButton__notAvailable, toastMessage} = style;

  return (
    <>
      <div className={formWrapper}>
        <form onSubmit={valueSubmit} ref={form}>
          <div data-aos="fade-left" data-aos-delay="200">
            <div className={name ? formBoxText : formBoxText_notActive}>
              <input
                id="textId"
                type="text"
                name="name"
                value={name}
                onChange={inputChange}
                // pattern="[A-Za-z].{3,}"
                // pattern="^[a-zA-ZĐ°-ŃŹĐ-ĐŻ]+(([' -][a-zA-ZĐ°-ŃŹĐ-ĐŻ ])?[a-zA-ZĐ°-ŃŹĐ-ĐŻ]*)*$"
                title="Name may contain only letters, apostrophe, dash and spaces. For example Adrian, Jacob Mercer, Charles de Batz de Castelmore d'Artagnan"
                required
              />
              <span>
                <IoIosContact />
              </span>
              <label htmlFor="textId">Imię</label>
            </div>
          </div>

          <div data-aos="fade-right" data-aos-delay="300">
            <div className={number ? formBoxText : formBoxText_notActive}>
              <input
              id="telId"
                type="tel"
                name="number"
                value={number}
                onChange={inputChange}
                // pattern="\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}"
                title="Phone number must be digits and can contain spaces, dashes, parentheses and can start with +"
              />
              <span>
                <IoIosPhonePortrait />
              </span>
              <label htmlFor="telId">Telefon</label>
            </div>
          </div>

          <div data-aos="fade-left" data-aos-delay="400">
            <div className={email ? formBoxText : formBoxText_notActive}>
              <input
                id="emailId"
                type="email"
                name="email"
                value={email}
                onChange={inputChange}
                pattern="^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA -Z]{2,5})$"
                required
              />
              <span>
                <IoIosMail />
              </span>
              <label htmlFor="emailId">E-mail</label>
            </div>
          </div>

          <div data-aos="fade-right" data-aos-delay="500">
            <div className={message ? formBoxText : formBoxText_notActive}>
              <textarea
                id="messageId"
                type="text"
                name="message"
                value={message}
                onChange={inputChange}
                title="Proszę o wpisanie wiadomości"
                required
              />
              <span>
                <IoIosFiling />
              </span>
              <label htmlFor="messageId">Wiadomość</label>
            </div>
          </div>

        {/* <div data-aos="fade-right" data-aos-delay="400"> */}
        <div>          
          <label className={policy ? checkLabel__checked : checkLabel} for-id="checkboxId">
            <input
              className={customCheck}
              type="checkbox"
              name="checkbox"
              onChange={inputChange}
              id="checkboxId"
              required
              title="Zaakceptuj politykę prywatności"
            />
            <p>
              Oświadczam, że akceptuję
              <a href={Policy} download> Politykę Prywatności.</a>
            </p>
          </label>
        </div>
      {/* </div> */}

          <button
            className={(name && email && message && policy) ? submitButton : submitButton__notAvailable}
            type="submit"
          >
            Wyślij wiadomość
          </button>
          <ToastContainer />
        </form>
      </div>
    </>
  );
};
